import axios from 'axios';

// ACTION TYPES
const name = 'profiles';
export const actionTypes = {
  SET_PROFILES: `${name}:set_profiles`,
  SET_SELECTED_PROFILE: `${name}:set_selected_profile`,
  SET_FILTER_PROFILE: `${name}:set_filter_profile`,
  SET_SORT_BY: `${name}:set_sort_by`,
  SET_SORT_DIR: `${name}:set_sort_dir`,
  SET_PAGE_NUM: `${name}:set_page_num`,
  SET_STATS: `${name}:set_stats`,
  SET_UPDATE_IN_PROGRESS: `${name}:set_update_in_progress`,
  SET_UPDATE_COMPLETE: `${name}:set_update_complete`,
  UPDATE_PROFILE: `${name}:update_profile`,
};

// ACTIONS
export function addProfile(profile, edit=false) {
  return (dispatch, getState) => {

    // Save the Okta Email
    profile.lastUpdatedBy = getState().params.email;

    const request = {
      method: 'POST',
      url: `${getState().params.apiUrl}/profiles/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      data: profile,
    };
    return axios(request)
      .then(response => {
        if(edit) {
          dispatch(setSelectedProfile(response.data));
        }
        dispatch(loadProfiles());
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function importProfiles(wtConnectID, file) {
  return (dispatch, getState) => {
    const formData = new FormData();
    formData.append('wtConnectID', wtConnectID);
    formData.append('file', file);
    const headers = {
      headers:`multipart/form-data; boundary=${formData._boundary}`,
      Authorization: `Token ${getState().params.token}`,
    };
    const request = {
        method: 'POST',
        url: `${getState().params.apiUrl}/profiles/upload/`,
        headers: headers,
        data: formData
    };
    return axios(request)
      .then(() => {
        return dispatch(loadProfiles());
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function loadProfiles() {
  return (dispatch, getState) => {
    // set filtering params
    const profile = getState().profiles.filterProfile;
    const params = {
      limit: 200, 
    };
    params.lastName = profile.lastName ? profile.lastName : '';
    params.firmName = profile.firmName ? profile.firmName : '';
    params.eventCode = profile.eventCode ? profile.eventCode : '';
    params.wtConnectID = profile.wtConnectID ? profile.wtConnectID : '';
    params.completed = profile.completed;
    params.sortBy = getState().profiles.sortBy;
    params.sortDir = getState().profiles.sortDir;
    //make request
    const request = {
      method: 'GET',
      url: `${getState().params.apiUrl}/profiles/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      params: params,
    };
    return axios(request)
      .then((response) => {
        dispatch({ type: actionTypes.SET_PROFILES, value: response.data });
      })
      .catch((error) => {
        console.error(error);
      });
  };
}

export function setSelectedProfile(profile) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_SELECTED_PROFILE, value: profile });
  };
}

export function setFilterProfile(profile) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_FILTER_PROFILE, value: profile });
    dispatch(loadProfiles());
  };
}

export function saveProfile(profile) {
  return (dispatch, getState) => {

    // Save the Okta Email
    profile.lastUpdatedBy = getState().params.email;

    const request = {
      method: 'PUT',
      url: `${getState().params.apiUrl}/profiles/${profile.id}/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      data: profile,
    };
    return axios(request)
      .then(response => {
        // dispatch(loadProfiles());
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function scoreProfile(profile) {
  return (dispatch, getState) => {

    // Save the Okta Email
    profile.lastUpdatedBy = getState().params.email;

    const request = {
      method: 'PUT',
      url: `${getState().params.apiUrl}/profiles/${profile.id}/score/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      data: profile,
    };
    return axios(request)
      .then(() => {
        // dispatch(loadProfiles());
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function downloadReport(profile) {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      responseType: 'blob',
      url: `${getState().params.apiUrl}/profiles/${profile.id}/report/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
    };
    return axios(request)
      .then(response => {
        const blob = new Blob([response.data], {type: 'application/pdf'});
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = data;
        link.download = `DPA_${profile.firstName}_${profile.lastName}_${profile.firmName.replace(/\s+/g,'')}.pdf`;
        link.click();
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function downloadReports(profiles) {
  const ids = profiles.map((profile) => profile.id);
  return (dispatch, getState) => {
    const request = {
      method: 'POST',
      responseType: 'blob',
      url: `${getState().params.apiUrl}/profiles/reports/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      data: ids
    };
    return axios(request)
      .then(response => {
        const blob = new Blob([response.data], {type: 'application/zip'});
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = data;
        link.download = `DPA_Reports.zip`;
        link.click();
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function deleteProfile(profile) {
  return (dispatch, getState) => {
    const request = {
      method: 'DELETE',
      url: `${getState().params.apiUrl}/profiles/${profile.id}/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
    };
    return axios(request)
      .then(() => {
        dispatch(loadProfiles());
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function deleteProfiles(profiles) {
  const ids = profiles.map((profile) => profile.id);
  return (dispatch, getState) => {
    const request = {
      method: 'POST',
      url: `${getState().params.apiUrl}/profiles/delete/`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      data: ids
    };
    return axios(request)
      .then(() => {
        dispatch(loadProfiles());
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function setSort(field, direction) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_SORT_BY, value: field });
    dispatch({ type: actionTypes.SET_SORT_DIR, value: direction });
    dispatch(loadProfiles());
  };
}

export function setPageNum(value) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_PAGE_NUM, value: value });
  };
}

export function getStatistics(wtConnectID='', eventCode='') {
  return (dispatch, getState) => {
    const params = {
      wtConnectID,
      eventCode,
    };
    //make request
    const request = {
      method: 'GET',
      url: `${getState().params.apiUrl}/profiles/statistics`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      params: params,
    };
    return axios(request)
      .then((response) => {
        dispatch({ type: actionTypes.SET_STATS, value: response.data });
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function downloadExcel(wtConnectID) {
  return (dispatch, getState) => {
    const params = {
      wtConnectID,
    };
    const request = {
      method: 'GET',
      responseType: 'blob',
      url: `${getState().params.apiUrl}/profiles/export`,
      headers: {
        Authorization: `Token ${getState().params.token}`,
      },
      params: params,
    };
    return axios(request)
      .then(response => {
        const blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = data;
        link.download = `${wtConnectID}-advisor-scores.xlsx`;
        link.click();
      })
      .catch(error => {
        console.log(error);
      });
  };
}
